import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten, isNapaLocationValid } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdAdd, MdArrowBack, MdArrowForward, MdCheck, MdCheckCircle, MdDelete, MdSms, MdWhatsapp } from "react-icons/md";

export default function StudentRegistrationForm({ classroomData, classroomUuid, classroomStreams = [], registrationCallback, suggestedStreamUuid = '' }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	
	/* Student Information */
	const [firstName, setFirstName] = useState('');
	const [middleName, setMiddleName] = useState('');
	const [lastName, setLastName] = useState('');
	const [nidaNumber, setNidaNumber] = useState('');
	const [passportPic, setPassportPic] = useState('');
	const [location, setLocation] = useState({});
	const [birthDate, setBirthDate] = useState('');
	const [residenceType, setResidenceType] = useState('boarding');
	const [gender, setGender] = useState('male');

	/* Parent Information */
	const [parentPhone, setParentPhone] = useState('');
	const [parentEmail, setParentEmail] = useState('');
	const [parentWhatsapp, setParentWhatsapp] = useState('');
	const [parentNidaNumber, setParentNidaNumber] = useState('');
	const [parentLocation, setParentLocation] = useState({});
	const [parentOccupation, setParentOccupation] = useState('');
	const [parentFirstName, setParentFirstName] = useState('');
	const [parentLastName, setParentLastName] = useState('');
	const [parentMiddleName, setParentMiddleName] = useState('');
	const [parentGender, setParentGender] = useState('male');
	
	/* Classroom and Stream information */
	const [streamUuid, setStreamUuid] = useState("");

	/* Registrations steps tracker */
	const [regStep, setRegStep] = useState('student');
	const [isRegSuccessful, setIsRegSuccessful] = useState(false);

	/*Files */
	const [file1Name, setFile1Name] = useState("");
	const [file2Name, setFile2Name] = useState("");
	const [file3Name, setFile3Name] = useState("");
	const [file4Name, setFile4Name] = useState("");
	const [file5Name, setFile5Name] = useState("");

  /** Individual Payment Cycles */
  const [applicableIndividualPaymentCycleUuids, setApplicableIndividualPaymentCycleUuids] = useState([])



	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
      appContext.getAllIndividualPaymentCycles(),
    ])
		setReady(true);
	}

	function resetForm() {
		setFirstName('');
		setMiddleName('');
		setLastName('');
		setNidaNumber('');
		setPassportPic(null);
		setLocation({});
		setBirthDate('');
		setResidenceType('boarding');
		setGender('male');

		setParentPhone('');
		setParentEmail('');
		setParentWhatsapp('');
		setParentNidaNumber('');
		setParentLocation({});
		setParentOccupation('');
		setParentFirstName('');
		setParentMiddleName('');
		setParentLastName('');
		setParentGender('male');

		setStreamUuid('');

		setRegStep('student');

		//clear files
		document.getElementById('_passportPic').value = '';
		setPassportPic(null);
		document.getElementById('_file1').value = '';
		document.getElementById('_file2').value = '';
		document.getElementById('_file3').value = '';
		document.getElementById('_file4').value = '';
		document.getElementById('_file5').value = '';

    setApplicableIndividualPaymentCycleUuids([]);
	}

  function addApplicableIndividualPaymentCycle() {
    setApplicableIndividualPaymentCycleUuids(_prev => {
      const _new = [..._prev];
      _new.push("");

      return _new;
    })
  }

  function editApplicableIndividualPaymentCycle(index, value) {
    setApplicableIndividualPaymentCycleUuids(_prev => {
      const _new = [..._prev];
      _new[index] = value;

      return _new;
    })
  }

  function deleteApplicableIndividualPaymentCycle(index) {
    setApplicableIndividualPaymentCycleUuids(_prev => {
      const _new = [..._prev];
      _new.splice(index, 1);

      return _new;
    })
  }
  

	async function registerStudent() {
		const _passportPic = document.getElementById('_passportPic').files[0];
		const _file1 = document.getElementById('_file1').files[0];
		const _file2 = document.getElementById('_file2').files[0];
		const _file3 = document.getElementById('_file3').files[0];
		const _file4 = document.getElementById('_file4').files[0];
		const _file5 = document.getElementById('_file5').files[0];

		if(validateStudentInfo() && validateClassroomInfo() && validateParentInfo() && validateClassroomInfo()) {
			setLoading(true);
			await callApi(
				'register-student',
				{
					firstName,
					middleName,
					lastName,
					nidaNumber,
					passportPic: (_passportPic || ''),
					location: JSON.stringify(location),
					birthDate,
					residenceType,
					gender,
					parentPhone,
					parentEmail,
					parentWhatsapp,
					parentNidaNumber,
					parentLocation: JSON.stringify(parentLocation),
					parentOccupation,
					parentFirstName,
					parentLastName,
					parentMiddleName,
					parentGender,
					classroomUuid,
					streamUuid,
					file1Name,
					file2Name,
					file3Name,
					file4Name,
					file5Name,
					file1: (_file1 || ''),
					file2: (_file2 || ''),
					file3: (_file3 || ''),
					file4: (_file4 || ''),
					file5: (_file5 || ''),
          applicableIndividualPaymentCycleUuidsString: JSON.stringify(applicableIndividualPaymentCycleUuids),
					schoolUuid: appContext.currentSchoolUuid,
				}
			).then(response => {
				if(response.status === 1) {
					setIsRegSuccessful(true);
					resetForm();
					
					if(registrationCallback) {
						registrationCallback()
					}

					appContext.tellMessage("Registration successful");

				} else {
					appContext.tellError(response.msg);
				}
			})
			setLoading(false);
		} else {
			//error messages will be handled autmatically by validators
		}
	}

	function validateClassroomInfo() {
		if(classroomData.applyStreams === 'yes') {
			if(classroomStreams && classroomStreams.length > 0) {
				if(streamUuid) {
					setRegStep('finalize');
					
					return true;
				} else {
					appContext.tellError("Please select stream for this student");
				}
			} else {
				appContext.tellError("This classroom supports streams but no streams have been created yet, please create streams first");
			}
		} else {
			setRegStep('finalize');
			return true;
		}
		

		return false;
	}

	function validateParentInfo() {
		if(parentPhone.trim().length === 12) {
			if(parentFirstName.trim().length > 0) {
				if(parentMiddleName.trim().length > 0) {
					if(parentLastName.trim().length > 0) {
			
						setRegStep('classroom');
						
						return true;

					} else {
						appContext.tellError("Invalid Parent's or Guardian's last name");
					}
				} else {
					appContext.tellError("Invalid Parent's or Guardian's middle name");
				}
			} else {
				appContext.tellError("Invalid Parent's or Guardian's first name");
			}
		} else {
			appContext.tellError("Invalid Parent's or Guardian's phone number (Should be in the format 255XXXXXXXXX)");
		}

		return false;
	}

	function validateStudentInfo() {
		const _passportPic = document.getElementById('_passportPic').files[0];

		if(firstName.trim().length > 0) {
			if(middleName.trim().length > 0) {
				if(lastName.trim().length > 0) {
					
					if(isNapaLocationValid(location)) {
						if(birthDate) {
							setRegStep('parent');
							
							return true;
						} else {
							appContext.tellError("Invalid student's birthdate");
						}
					} else {
						appContext.tellError("Invalid student's Physical Address")
					}
					
					
				} else {
					appContext.tellError("Invalid student's last name");
				}
			} else {
				appContext.tellError("Invalid student's middle name");
			}
		} else {
			appContext.tellError("Invalid student's first name");
		}

		return false;
	}

	function handleFileChange(event) {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      // Check if the file is an image
      if (file.type.match('image.*')) {
        const reader = new FileReader();
        
        // This will run once the image is successfully read
        reader.onload = function (e) {
          setPassportPic(e.target.result); // Update the state with the image data URL
        };
        
        // Read the image file as a data URL
        reader.readAsDataURL(file);
      } else {
        appContext.tellError('Please select a valid image file.');
      }
    }
  };
	

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		setStreamUuid(suggestedStreamUuid);
	}, [ suggestedStreamUuid ])

	useEffect(() => {
		try {
			document.getElementById('_studentRegFormTop').scrollTop({ behavior: 'smooth' });
		} catch (error) {
			
		}
	}, [ regStep ])

  useEffect(() => {
    if(parentPhone) {
      setParentWhatsapp(parentPhone);
    }
  }, [parentPhone])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
		
			<div
				style={{
					width: "100%",
				}}
				id="_studentRegForm"
			>
				{
					(isRegSuccessful) ?
					<div className="row">
						<div className="col-md-12 text-center">
							<MdCheckCircle size={64}/>
							
							<h6
								className="font-light"
								style={{
									fontSize: "24px"
								}}
							>
								Student Registration was completed
							</h6>

							<button
								className="btn btn-rounded btn-padded btn-outline-dark mt-4 mb-4"
								onClick={() => {
									setRegStep('student');
									setIsRegSuccessful(false);
								}}
							>
								Register Again
							</button>
						</div>
					</div>
					:
					<>
						
						<div className="row" >
							<div className="col-md-12 mt-2 mb-2 text-start">

								<h6 
									className="sub-section-title"
									style={{
										marginBottom: "20px"
									}}
								>
									<span className="badge bg-primary" style={{ fontSize: "12px" }}>STEP 1</span>
									<br/>
									Student's Details
								</h6>
								

								
								<label className="form-label">Students Passport Picture</label>
								<div className="form-text">Click box below to select</div>
								<div
									style={{
										width: "150px",
										height: "150px",
										//margin: "0 auto",
										borderRadius: "20px",
										overflow: "hidden",
										cursor: "pointer",
										overflow: "hidden",
									}}
									className="bg-surface mShadow1"
									onClick={() => document.getElementById('_passportPic').click()}
								>
									{
										(passportPic) ?
										<img
											src={passportPic}
											style={{
												width: "100%",
												height: "100%",
											}}
										/>
										:""
									}
								</div>
								<input
									hidden
									type="file"
									id="_passportPic"
									accept="image/png, image/jpg, image/jpeg"
									onChange={handleFileChange}
								/>
								
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">First name</label>
								<input
									className="form-control"
									value={firstName}
									onChange={e => setFirstName(e.target.value)}
								/>
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Middle name</label>
								<input
									className="form-control"
									value={middleName}
									onChange={e => setMiddleName(e.target.value)}
								/>
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Last name</label>
								<input
									className="form-control"
									value={lastName}
									onChange={e => setLastName(e.target.value)}
								/>
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Gender</label>
								<select
									className="form-control"
									value={gender}
									onChange={e => setGender(e.target.value)}
								>
									<option value='male'>Male</option>
									<option value='female'>Female</option>
								</select>
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Date of Birth</label>
								<input
									className="form-control"
									type="date"
									value={birthDate}
									onChange={e => setBirthDate(e.target.value)}
								/>
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">NIDA Number</label>
								<input
									className="form-control"
									value={nidaNumber}
									onChange={e => setNidaNumber(e.target.value)}
								/>
								<div className="form-text">Optional</div>
							</div>

							

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Student Residency</label>
								<select
									className="form-control"
									value={residenceType}
									onChange={e => setResidenceType(e.target.value)}
								>
									<option value='day'>Day</option>
									<option value='hostel'>Hostel</option>
									<option value='boarding'>Boarding</option>
								</select>
							</div>

							<div className="col-md-12 mt-2 mb-2 text-end">
								<hr/>
								
							</div>
						</div>
						
						<div className="row">
							<div className="col-md-12 mt-2 mb-2 text-start">

								<h6 
									className="sub-section-title"
									style={{
										marginBottom: "20px"
									}}
								>
									<span className="badge bg-primary" style={{ fontSize: "12px" }}>STEP 2</span>
									<br/>
									Parent's or Guardian's Details
								</h6>
				
								
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Parent's or Guardian's First name</label>
								<input
									className="form-control"
									value={parentFirstName}
									onChange={e => setParentFirstName(e.target.value)}
								/>
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Parent's or Guardian's Middle name</label>
								<input
									className="form-control"
									value={parentMiddleName}
									onChange={e => setParentMiddleName(e.target.value)}
								/>
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Parent's or Guardian's Last name</label>
								<input
									className="form-control"
									value={parentLastName}
									onChange={e => setParentLastName(e.target.value)}
								/>
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Parent's or Guardian's Gender</label>
								<select
									className="form-control"
									value={parentGender}
									onChange={e => setParentGender(e.target.value)}
								>
									<option value='male'>Male</option>
									<option value='female'>Female</option>
								</select>
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Parent's or Guardian's Phone Number</label>
								<input
									className="form-control"
									value={parentPhone}
									onChange={e => setParentPhone(e.target.value)}
									maxLength={12}
								/>
								<div className="form-text">Eg: 255XXXXXXXXX</div>
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Parent's or Guardian's Email Address</label>
								<input
									className="form-control"
									value={parentEmail}
									onChange={e => setParentEmail(e.target.value)}
								/>
								<div className="form-text">Optional</div>
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Parent's or Guardian's  WhatsApp Number</label>
								<input
									className="form-control"
									value={parentWhatsapp}
									onChange={e => setParentWhatsapp(e.target.value)}
									maxLength={12}
								/>
								<div className="form-text">Eg: 255XXXXXXXXX, Optional</div>
							</div>

							

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Parent's or Guardian's NIDA Number</label>
								<input
									className="form-control"
									value={parentNidaNumber}
									onChange={e => setParentNidaNumber(e.target.value)}
								/>
								<div className="form-text">Optional</div>
							</div>

							<div className="col-md-6 mt-2 mb-2">
								<label className="form-label">Parent's or Guardian's Occupation</label>
								<input
									className="form-control"
									value={parentOccupation}
									onChange={e => setParentOccupation(e.target.value)}
								/>
								<div className="form-text">Optional</div>
							</div>


							<div className="col-md-12 mt-2 mb-2 text-end">
								<hr/>
								
							</div>
						</div>
													
						<div className="row">
							<div className="col-md-12 mt-2 mb-2 text-start">

								<h6 
									className="sub-section-title"
									style={{
										marginBottom: "20px"
									}}
								>
									<span className="badge bg-primary" style={{ fontSize: "12px" }}>STEP 3</span>
									<br/>
									Classroom Setup and Attachments
								</h6>
				
								
							</div>

							<div className="col-md-12 mt-2 mb-2">
								<label className="form-label">Classroom</label>
								<h6
									style={{
										fontSize: "32px",

									}}
									className="font-light"
								>
									{classroomData.name}
								</h6>
							</div>

							{
								(classroomData.applyStreams === 'yes') ?
								<div className="col-md-12 mt-2 mb-2">
									<label className="form-label">Select Stream</label>
									<select
										className="form-control"
										value={streamUuid}
										onChange={(e) => setStreamUuid(e.target.value)}
										disabled={(suggestedStreamUuid) ? true : false}
									>
										<option value="">Select Stream</option>
										{
											(classroomStreams && classroomStreams.length > 0) ?
											classroomStreams.map((item, i) => {
												return (
													<option key={i} value={item.uuid}>{item.name}</option>
												)
											})
											:""
										}
									</select>
								</div>
								:
								""
							}

							<div className="col-md-12 mt-2 mb-2">
								<h6 className="sub-section-title">Files & Attachments</h6>
								<div className="form-text">Optional</div>

								<div className="row">
									<div className="col-6 mt-1 mb-1">
										<label className="form-label">Attachment1 Title</label>
										<input
											value={file1Name}
											onChange={(e) => setFile1Name(e.target.value)}
											className="form-control"
										/>
									</div>

									<div className="col-6 mt-1 mb-1">
										<label className="form-label">Select Attachment1</label>
										<input
											id="_file1"
											className="form-control"
											type="file"
											accept="image/jpg, image/jpeg, image/png, application/pdf"
										/>
									</div>

								</div>

								<div className="row">
									<div className="col-6 mt-1 mb-1">
										<label className="form-label">Attachment2 Title</label>
										<input
											value={file2Name}
											onChange={(e) => setFile2Name(e.target.value)}
											className="form-control"
										/>
									</div>

									<div className="col-6 mt-1 mb-1">
										<label className="form-label">Select Attachment2</label>
										<input
											id="_file2"
											className="form-control"
											type="file"
											accept="image/jpg, image/jpeg, image/png, application/pdf"
										/>
									</div>

								</div>

								<div className="row">
									<div className="col-6 mt-1 mb-1">
										<label className="form-label">Attachment3 Title</label>
										<input
											value={file3Name}
											onChange={(e) => setFile3Name(e.target.value)}
											className="form-control"
										/>
									</div>

									<div className="col-6 mt-1 mb-1">
										<label className="form-label">Select Attachment3</label>
										<input
											id="_file3"
											className="form-control"
											type="file"
											accept="image/jpg, image/jpeg, image/png, application/pdf"
										/>
									</div>

								</div>

								<div className="row">
									<div className="col-6 mt-1 mb-1">
										<label className="form-label">Attachment4 Title</label>
										<input
											value={file4Name}
											onChange={(e) => setFile4Name(e.target.value)}
											className="form-control"
										/>
									</div>

									<div className="col-6 mt-1 mb-1">
										<label className="form-label">Select Attachment4</label>
										<input
											id="_file4"
											className="form-control"
											type="file"
											accept="image/jpg, image/jpeg, image/png, application/pdf"
										/>
									</div>

								</div>

								<div className="row">
									<div className="col-6 mt-1 mb-1">
										<label className="form-label">Attachment5 Title</label>
										<input
											value={file5Name}
											onChange={(e) => setFile5Name(e.target.value)}
											className="form-control"
										/>
									</div>

									<div className="col-6 mt-1 mb-1">
										<label className="form-label">Select Attachment5</label>
										<input
											id="_file5"
											className="form-control"
											type="file"
											accept="image/jpg, image/jpeg, image/png, application/pdf"
										/>
									</div>

								</div>

							</div>
							

							<div className="col-md-12 mt-2 mb-2">
								<hr/>
								
							</div>
						</div>

            
            <div className="row">
							<div className="col-md-12 mt-2 mb-2 text-start">

								<h6 
									className="sub-section-title"
									style={{
										marginBottom: "20px"
									}}
								>
									<span className="badge bg-primary" style={{ fontSize: "12px" }}>STEP 4</span>
									<br/>
									Applicable individual Payment Cycles
								</h6>
				
								
							</div>

							<div className="col-md-12 mt-2 mb-2">
								<label className="form-label">Select Applicable Individual Payment Cycles</label>
                <div
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "2px solid var(--mutedColor)"
                  }}
                >
                  <div
                    style={{
                      
                    }}
                  >
                    <table
                      className="table table-striped"
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          <th>Individual Payment Cycles</th>
                          <th></th>
                        </tr>
                      </thead>
      
                      <tbody>
                        {
                          applicableIndividualPaymentCycleUuids.map((item, i) => {
                            return (
                              <tr key={i}>
                                <td>
                                  <select
                                    className="form-control"
                                    value={item}
                                    onChange={(e) => {
                                      editApplicableIndividualPaymentCycle(i, e.target.value)
                                    }}
                                  >
                                    <option value="">Select</option>
                                    {
                                      (appContext.allIndividualPaymentCycles && appContext.allIndividualPaymentCycles.length > 0) ?
                                      appContext.allIndividualPaymentCycles.map((item, i) => {
                                        return (
                                          <option value={item.uuid} key={i}>{item.title}</option>
                                        )
                                      })
                                      :""
                                    }
                                  </select>
                                </td>
      
                                <td
                                >
                                  <MdDelete
                                    size={18}
                                    className="text-danger"
                                    style={{
                                      cursor: "pointer"
                                    }}
                                    onClick={() => {
                                      deleteApplicableIndividualPaymentCycle(i)
                                    }}
                                  />
                                </td>
                              </tr>
                            )
                          })
                        }
      
                        
                      </tbody>
                    </table>
      
                    
                  </div>
      
                  <button
                    className="btn btn-outline-dark btn-sm mt-2"
                    onClick={() => {
                      addApplicableIndividualPaymentCycle()
                    }}
                  >
                    <MdAdd
                      size={24}
                      
                    />
                  </button>
                </div>
                
							</div>

							
						</div>
            
						
						<div className="row">
							

							<div className="col-md-12 mt-2 mb-2 text-center">
								

								<button
									className="btn btn-padded btn-block btn-secondary btn-rounded btn-padded"
									onClick={registerStudent}
								>
									Submit & Register Student
								</button>
							</div>

							

							
						</div>
							
					</>
				}
			</div>
								
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}